import React from 'react'
import cn from 'classnames'

interface DividerProps {
    className: string
}

export const Divider = ({ className }: DividerProps) => {
    return (
        <div className={cn('h-px w-full bg-grey my-5', className)}>
        </div>
    )
}